import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  buttons: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '400',
    minWidth: 'unset'
  },
  outlined: {
    background: '#FFFFFF',
    fontWeight: '500',
    '&:hover': {
      background: '#FFFFFF',
      opacity: 0.8
    },
    '&:focus': {
      background: '#FFFFFF',
      opacity: 0.8
    }
  },
  icon: {
    fill: theme.palette.primary.main
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  statusChip: {
    borderRadius: '4px',
    padding: '4px 8px',
    fontWeight: 500,
    fontSize: '12px',
    textTransform: 'uppercase'
  },
  statusPending: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark
  },
  statusSuccess: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark
  },
  statusFailed: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark
  }
}));
